export default __webpack_public_path__ + "static/media/logo-480x235-yellow.09962a8d.svg";